// extracted by mini-css-extract-plugin
export default {"option_set":"summary-settings_option_set__j59ju"};